export default __webpack_public_path__ + "static/media/exportdata-active.a4e23480.svg";